<div class="modal-comunicado">
  <app-modal-header 
    title="Comunicados" 
    (closeEmitter)="closeModal()"  
    checkBoxText="Marcar como visto"
    (checkboxEmitter)="changeCommunicationViewed($event)"/>

  <app-banner-slides 
    [bannerSlidesInput]="slidesData" 

    [hasGradient]="false" 
    [isModal]="true"
    (currentSlideChange)="currentSlideChange($event)"
    (linkOpenedChange)="changeCommunicationViewedByLink($event)"
    />
</div>